import * as React from "react";
import { useState, useEffect } from "react";
import { useNavigate } from "react-router-dom";
import { styled, useTheme } from "@mui/material/styles";
import {
  Box,
  Drawer,
  CssBaseline,
  List,
  ListItem,
  ListItemButton,
  ListItemIcon,
  ListItemText,
} from "@mui/material";
import "./DesktopMiniDrawer.css";
import Vector from "../../../images/Vector.svg";
import { useMediaQuery } from "@mui/material";
import { useLocation } from "react-router-dom";
import CryptoJS from "crypto-js";

export default function DesktopMiniDrawer() {
  const theme = useTheme();
  const [open, setOpen] = useState(true);
  const navigate = useNavigate();
  const [selectedMenuItem, setSelectedMenuItem] = useState(null);

  const location = useLocation();
  const searchParams = new URLSearchParams(location.search);
  const encryptedRelocationID = searchParams.get("ID");
  const Relocation_ID = decryptRelocationID(encryptedRelocationID);
  const encrypt = encryptRelocationID(Relocation_ID, "dbbworldwidepvtltd");

  // Responsive breakpoints for laptop (lg) and tablet (md)
  const isLaptop = useMediaQuery(theme.breakpoints.up("lg"));
  const isTablet = useMediaQuery(theme.breakpoints.between("md", "lg"));

  function encryptRelocationID(Relocation_ID, key) {
    const ciphertext = CryptoJS.AES.encrypt(
      Relocation_ID.toString(),
      key
    ).toString();
    return encodeURIComponent(ciphertext);
  }

  // Drawer width adjustments based on screen size
  const drawerWidth = isLaptop ? 240 : isTablet ? 180 : 120;

  // Handle order summary open state
  const handleOrderSummaryOpen = () => {
    setSelectedMenuItem("OrderSummary");
    const url = `/orderSummary?ID=${encrypt}`;
    window.open(url, "_self");
  };

  function decryptRelocationID(ciphertext) {
    try {
      const bytes = CryptoJS.AES.decrypt(
        decodeURIComponent(ciphertext),
        "dbbworldwidepvtltd"
      );
      return bytes.toString(CryptoJS.enc.Utf8);
    } catch (error) {
      console.error("Error decrypting Relocation_ID:", error);

      return null;
    }
  }

  const handleQuotationPaymentOpen = () => {
    //  if (open) setOrderSummaryOpen(!orderSummaryOpen);
    // navigate("/quotation");
    setSelectedMenuItem("Quotation");
    const url = `/quotation?ID=${encrypt}`;
    window.open(url, "_self");
  };

  return (
    <Box sx={{ display: "flex" }}>
      <CssBaseline />
      <Drawer
        variant="permanent"
        open={open}
        sx={{
          width: drawerWidth,
          flexShrink: 0,
          "& .MuiDrawer-paper": {
            width: drawerWidth,
            top: "74px",
            transition: "width 0.9s ease-in-out", // Smooth transition for drawer width
          },
        }}
      >
        {/* Drawer Header */}
        {/* Order Summary */}
        <List
          style={{ marginTop: "0px", marginBottom: "0px" }}
          // className={`${open ? "activeList" : ""} mainDashboard`}
        >
          <ListItem
            key="OrderSummary"
            disablePadding
            sx={{
              display: "block",
              marginTop: "0px",
              marginBottom: "0px",
              backgroundColor:
                selectedMenuItem === "OrderSummary" ? "#f0f0f0" : "transparent",
            }}
          >
            <ListItemButton
              sx={{
                minHeight: 48,
                justifyContent: open ? "initial" : "center", // Dynamic alignment when drawer is open/closed
                px: 2.5,
              }}
              onClick={handleOrderSummaryOpen}
            >
              <div
                style={{
                  display: "flex",
                  marginTop: "4px",
                  alignItems: "center", // Vertically centers the text and image
                  justifyContent: "space-between", // Ensures both text and image are spaced correctly
                  width: "100%", // Full width to manage responsive layout
                }}
              >
                <ListItemText
                  className="minidrawer-itemtext"
                  primary="Order Summary"
                  sx={{ opacity: open ? 1 : 0 }}
                  style={{
                    marginBottom: "0px",
                    marginTop: "0px",
                    flexGrow: 1, // Ensures the text takes up the available space
                    marginRight: "8px", // Space between text and image
                    textAlign: open ? "left" : "center", // Adjust text alignment when drawer is closed
                  }}
                />
                <img
                  style={{
                    width: isLaptop ? "7px" : "5px", // Adjust icon size based on screen size
                    cursor: "pointer", // Cursor pointer for hover effect
                    transition: "0.3s ease-in-out", // Smooth transition for responsiveness
                  }}
                  alt="Loading..."
                  className="form-image-MiniDrawer"
                  src={Vector}
                />
              </div>
            </ListItemButton>
          </ListItem>
        </List>

        <List
          style={{ marginTop: "0px", marginBottom: "0px" }}
          // className={`${open ? "activeList" : ""} mainDashboard`}
        >
          <ListItem
            key="Quotation"
            disablePadding
            sx={{
              display: "block",
              marginTop: "0px",
              marginBottom: "0px",
              backgroundColor:
                selectedMenuItem === "Quotation" ? "#f0f0f0" : "transparent",
            }}
          >
            <ListItemButton
              sx={{
                minHeight: 48,
                justifyContent: open ? "initial" : "center", // Dynamic alignment when drawer is open/closed
                px: 2.5,
              }}
              onClick={handleQuotationPaymentOpen}
            >
              <div
                style={{
                  display: "flex",
                  marginTop: "4px",
                  alignItems: "center", // Vertically centers the text and image
                  justifyContent: "space-between", // Ensures both text and image are spaced correctly
                  width: "100%", // Full width to manage responsive layout
                }}
              >
                <ListItemText
                  className="minidrawer-itemtext"
                  primary="Quotation & Payment Details"
                  sx={{ opacity: open ? 1 : 0 }}
                  style={{
                    marginBottom: "0px",
                    marginTop: "0px",
                    flexGrow: 1, // Ensures the text takes up the available space
                    marginRight: "8px", // Space between text and image
                    textAlign: open ? "left" : "center", // Adjust text alignment when drawer is closed
                  }}
                />
                <img
                  style={{
                    width: isLaptop ? "7px" : "5px", // Adjust icon size based on screen size
                    cursor: "pointer", // Cursor pointer for hover effect
                    transition: "0.3s ease-in-out", // Smooth transition for responsiveness
                  }}
                  alt="Loading..."
                  className="form-image-MiniDrawer"
                  src={Vector}
                />
              </div>
            </ListItemButton>
          </ListItem>
        </List>
      </Drawer>
    </Box>
  );
}
